import { DialogContent } from '@material-ui/core/';
import { withStyles } from '@material-ui/core/styles';
var ClosableDialogContent = withStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(2),
    },
}); })(DialogContent);
export default ClosableDialogContent;
//# sourceMappingURL=ClosableDialogContent.js.map